<template>
  <div class="bid-bg">
    <div span="12" class="ad">
      <div class="tip">
        <i></i>
        <span>{{$t('label.w135')}}</span>
      </div>
      <ul class="desc">
        <li>{{$t('other.w97')}}</li>
        <li>{{$t('other.w98')}}</li>
        <li>{{$t('other.w99')}}
          <router-link :to="{name:'security'}">{{$t('nav.w71')}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.bid-bg {
  height: 320px;
  background: url("../../assets/assetcenter/auto_setbg.png") no-repeat right;
  background-size: 416px 318px;
  .ad {
    padding: 30px 0 0 110px;
    background: url("../../assets/assetcenter/public_quotes.png") no-repeat;
    background-size: 78px 74px;
    background-position: 80px 90px;
    h3 {
      font-size: 48px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    p {
      font-size: 14px;
      color: rgba(179, 179, 182, 1);
    }
    .tip {
      font-weight: 500;
      color: rgba(94, 143, 252, 1);
      font-size: 14px;
      margin-top: 30px;
      span {
        margin-left: 5px;
      }
      i {
        display: inline-block;
        background: url("../../assets/assetcenter/public_hint.png") no-repeat;
        width: 14px;
        height: 13px;
        background-size: cover;
      }
    }
    .desc {
      margin-top: 30px;
      margin-left: 15px;
      position: relative;
      li {
        width: 439px;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 20px;
        letter-spacing: 1;
      }
    }
  }
}
</style>
